<div class="read-only-container" *ngIf="dataLoaded | async">
  <div class="body-contents">
    <p class="section-header">{{"data-refresh.read-only.header" | translate}}</p>
    <p class="sub-header">
      {{"data-refresh.read-only.subtext" | translate}}
    </p>
    <div class="read-only-data-container">
      <div class="read-only-row">
        <p>{{"data-refresh.read-only.minimum-hourly" | translate}}</p>
        <p [innerText]="formatAmount(this.jobPreferencesService.jobPreferencesData.money.minimumHourlyRate)">$85/hr</p>
      </div>
      <div class="read-only-row">
        <p>{{"data-refresh.read-only.target-hourly" | translate}}</p>
        <p [innerText]="formatAmount(this.jobPreferencesService.jobPreferencesData.money.desiredHourlyRate)">$85/hr</p>
      </div>
      <div class="read-only-row">
        <p>{{"data-refresh.read-only.minimum-salary" | translate}}</p>
        <p [innerText]="formatAmount(this.jobPreferencesService.jobPreferencesData.money.minimumYearlySalary)">$85-100k</p>
      </div>
      <div class="read-only-row">
        <p>{{"data-refresh.read-only.target-salary" | translate}}</p>
        <p [innerText]="formatAmount(this.jobPreferencesService.jobPreferencesData.money.desiredYearlySalary)">$85-100k</p>
      </div>
      <div class="read-only-row">
        <p>{{"data-refresh.read-only.preferred-work-type" | translate}}</p>
        <p [innerText]="formatSelections(this.WORK_TYPE)">Temporary</p>
      </div>
      <div class="read-only-row">
        <p>{{"data-refresh.read-only.preferred-hours" | translate}}</p>
        <p [innerText]="formatSelections(this.HOURS)">Full-time</p>
      </div>
      <div class="read-only-row">
        <p>{{"data-refresh.read-only.preferred-workplace" | translate}}</p>
        <p [innerText]="formatSelections(this.WORK_LOCATION)">On-site;remote</p>
      </div>
    </div>
    <div class="read-only-actions">
      <button id="readOnlyConfirmButton" class="confirm-button read-only-button" (click)="looksGoodButtonClicked()"> Looks Good </button>
      <button id="readOnlyEditButton" class="edit-button read-only-button" (click)="editButtonClicked()"> Edit </button>
    </div>
  </div>
  <span data-iframe-height></span>
</div>
